import { render, staticRenderFns } from "./SwappTasksIssuesDialog.vue?vue&type=template&id=2cfda597&scoped=true&"
import script from "./SwappTasksIssuesDialog.vue?vue&type=script&lang=js&"
export * from "./SwappTasksIssuesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfda597",
  null
  
)

export default component.exports